'use client';

import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {
  useAuthorizedProfile,
  useAuthProgressState,
} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

export const PageViewReporter = () => {
  const pathname = usePathname();
  const userInfo = useAuthorizedProfile();
  const authState = useAuthProgressState();

  useEffect(() => {
    if (authState === 'failed' || authState === 'finished') {
      logTmrEvent({
        logEvent: 'webVitrina.view',
        params: {
          vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
        },
      });
    }
  }, [pathname, authState]);

  return null;
};
